"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _imgAlt = _interopRequireDefault(require("./img-alt"));

var _imgAltFilename = _interopRequireDefault(require("./img-alt-filename"));

var _tableCaption = _interopRequireDefault(require("./table-caption"));

var _tableHeader = _interopRequireDefault(require("./table-header"));

var _tableHeaderScope = _interopRequireDefault(require("./table-header-scope"));

var _smallTextContrast = _interopRequireDefault(require("./small-text-contrast"));

var _largeTextContrast = _interopRequireDefault(require("./large-text-contrast"));

var _adjacentLinks = _interopRequireDefault(require("./adjacent-links"));

var _headingsSequence = _interopRequireDefault(require("./headings-sequence"));

var _imgAltLength = _interopRequireDefault(require("./img-alt-length"));

var _paragraphsForHeadings = _interopRequireDefault(require("./paragraphs-for-headings"));

var _listStructure = _interopRequireDefault(require("./list-structure"));

var _headingsStartAtH = _interopRequireDefault(require("./headings-start-at-h2"));

var _default = [_imgAlt.default, _imgAltFilename.default, _tableCaption.default, _tableHeader.default, _tableHeaderScope.default, _smallTextContrast.default, _largeTextContrast.default, _adjacentLinks.default, _headingsSequence.default, _imgAltLength.default, _paragraphsForHeadings.default, _listStructure.default, _headingsStartAtH.default];
exports.default = _default;